import { render, staticRenderFns } from "./FlowersIcon.vue?vue&type=template&id=bd42a3fc&"
import script from "./FlowersIcon.vue?vue&type=script&lang=ts&"
export * from "./FlowersIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bd42a3fc', component.options)
    } else {
      api.reload('bd42a3fc', component.options)
    }
    module.hot.accept("./FlowersIcon.vue?vue&type=template&id=bd42a3fc&", function () {
      api.rerender('bd42a3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/FlowersIcon.vue"
export default component.exports